import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UnitQuizCooldownRemaining } from './unit-quiz-cooldown-remaining';

export const TAKE_UNIT_QUIZ_LOCKED_TITLE_ID = 'take-unit-quiz-locked-title';

@Component({
  selector: 'lp2-take-unit-quiz-locked-modal',
  templateUrl: './take-unit-quiz-locked-modal.component.html',
  styleUrls: ['./take-unit-quiz-locked-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class TakeUnitQuizLockedModalComponent {
  @Input() cooldownHours: number;
  @Input() remaining: UnitQuizCooldownRemaining;

  readonly titleId = TAKE_UNIT_QUIZ_LOCKED_TITLE_ID;

  constructor(private readonly modal: NgbActiveModal) {}

  keepLearning() {
    this.modal.dismiss();
  }
}



// WEBPACK FOOTER //
// ./ts/app/home/mini-lesson-section/take-unit-quiz/take-unit-quiz-locked-modal.component.ts